
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire0426"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire0426"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("kyEFX", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $ef7689007096c8a0$export$6503ec6e8aabbaf; }, function (v) { return $ef7689007096c8a0$export$6503ec6e8aabbaf = v; });
var $ef7689007096c8a0$export$6503ec6e8aabbaf;
var $ef7689007096c8a0$export$f7ad0328861e2f03;
"use strict";
var $ef7689007096c8a0$var$mapping = new Map();
function $ef7689007096c8a0$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$ef7689007096c8a0$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $ef7689007096c8a0$var$resolve(id) {
    var resolved = $ef7689007096c8a0$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$ef7689007096c8a0$export$6503ec6e8aabbaf = $ef7689007096c8a0$var$register;
$ef7689007096c8a0$export$f7ad0328861e2f03 = $ef7689007096c8a0$var$resolve;

});

var $e83d0ee508f5ce68$exports = {};

(parcelRequire("kyEFX")).register(new URL("", import.meta.url).toString(), JSON.parse('["6TNLe","index.dc40fdac.js","eWh9u","dice-1.8a72e595.png","fxIWc","dice-2.ddc1b739.png","e4cXh","dice-3.433d125d.png","l3w72","dice-4.37e5f716.png","kcygN","dice-5.b7ae9b64.png","j6KrB","dice-6.9e5fc14a.png"]'));

// Selecting Elements
var $f3743494ecaa78c9$exports = {};
$f3743494ecaa78c9$exports = new URL("dice-1.8a72e595.png", import.meta.url).toString();


var $dbcf362cb4ca3386$exports = {};
$dbcf362cb4ca3386$exports = new URL("dice-2.ddc1b739.png", import.meta.url).toString();


var $006d3157770dd857$exports = {};
$006d3157770dd857$exports = new URL("dice-3.433d125d.png", import.meta.url).toString();


var $c1f01abfd5e35865$exports = {};
$c1f01abfd5e35865$exports = new URL("dice-4.37e5f716.png", import.meta.url).toString();


var $438d67e1900a3cce$exports = {};
$438d67e1900a3cce$exports = new URL("dice-5.b7ae9b64.png", import.meta.url).toString();


var $b60fa3bf273ca01d$exports = {};
$b60fa3bf273ca01d$exports = new URL("dice-6.9e5fc14a.png", import.meta.url).toString();


const $1ee2b6306238ec66$var$player0El = document.querySelector(".player--0");
const $1ee2b6306238ec66$var$player1El = document.querySelector(".player--1");
const $1ee2b6306238ec66$var$score0El = document.querySelector("#score--0");
const $1ee2b6306238ec66$var$score1El = document.getElementById("score--1");
const $1ee2b6306238ec66$var$current0El = document.getElementById("current--0");
const $1ee2b6306238ec66$var$current1El = document.getElementById("current--1");
const $1ee2b6306238ec66$var$diceEl = document.querySelector(".dice");
const $1ee2b6306238ec66$var$btnNew = document.querySelector(".btn--new");
const $1ee2b6306238ec66$var$btnRoll = document.querySelector(".btn--roll");
const $1ee2b6306238ec66$var$btnHold = document.querySelector(".btn--hold");
// Starting Conditions
let $1ee2b6306238ec66$var$scores, $1ee2b6306238ec66$var$currentScore, $1ee2b6306238ec66$var$activePlayer, $1ee2b6306238ec66$var$playing;
const $1ee2b6306238ec66$var$init = function() {
    $1ee2b6306238ec66$var$scores = [
        0,
        0
    ];
    $1ee2b6306238ec66$var$currentScore = 0;
    $1ee2b6306238ec66$var$activePlayer = 0;
    $1ee2b6306238ec66$var$playing = true;
    $1ee2b6306238ec66$var$score0El.textContent = 0;
    $1ee2b6306238ec66$var$score1El.textContent = 0;
    $1ee2b6306238ec66$var$current0El.textContent = 0;
    $1ee2b6306238ec66$var$current1El.textContent = 0;
    $1ee2b6306238ec66$var$diceEl.classList.add("hidden");
    $1ee2b6306238ec66$var$player0El.classList.remove("player--winner");
    $1ee2b6306238ec66$var$player1El.classList.remove("player--winner");
    $1ee2b6306238ec66$var$player1El.classList.remove("player--active");
    $1ee2b6306238ec66$var$player0El.classList.add("player--active");
};
$1ee2b6306238ec66$var$init();
const $1ee2b6306238ec66$var$switchPlayer = function() {
    $1ee2b6306238ec66$var$currentScore = 0;
    document.getElementById(`current--${$1ee2b6306238ec66$var$activePlayer}`).textContent = 0;
    $1ee2b6306238ec66$var$activePlayer = $1ee2b6306238ec66$var$activePlayer === 0 ? 1 : 0;
    $1ee2b6306238ec66$var$player0El.classList.toggle("player--active");
    $1ee2b6306238ec66$var$player1El.classList.toggle("player--active");
};
// Rolling Dice Functionality
$1ee2b6306238ec66$var$btnRoll.addEventListener("click", function() {
    if ($1ee2b6306238ec66$var$playing) {
        // 1 Generate random dice roll
        const dice = Math.trunc(Math.random() * 6) + 1;
        // 2 Display Roll
        $1ee2b6306238ec66$var$diceEl.classList.remove("hidden");
        let diceSrc;
        switch(dice){
            case 1:
                diceSrc = (0, (/*@__PURE__*/$parcel$interopDefault($f3743494ecaa78c9$exports)));
                break;
            case 2:
                diceSrc = (0, (/*@__PURE__*/$parcel$interopDefault($dbcf362cb4ca3386$exports)));
                break;
            case 3:
                diceSrc = (0, (/*@__PURE__*/$parcel$interopDefault($006d3157770dd857$exports)));
                break;
            case 4:
                diceSrc = (0, (/*@__PURE__*/$parcel$interopDefault($c1f01abfd5e35865$exports)));
                break;
            case 5:
                diceSrc = (0, (/*@__PURE__*/$parcel$interopDefault($438d67e1900a3cce$exports)));
                break;
            case 6:
                diceSrc = (0, (/*@__PURE__*/$parcel$interopDefault($b60fa3bf273ca01d$exports)));
                break;
            default:
                diceSrc = ""; // Handle default case
        }
        $1ee2b6306238ec66$var$diceEl.src = diceSrc;
        // 3 Check for a roll of 1
        if (dice !== 1) {
            // Not a 1, add to score
            $1ee2b6306238ec66$var$currentScore += dice;
            document.getElementById(`current--${$1ee2b6306238ec66$var$activePlayer}`).textContent = $1ee2b6306238ec66$var$currentScore;
        } else // if true switch to next player
        $1ee2b6306238ec66$var$switchPlayer();
    }
});
$1ee2b6306238ec66$var$btnHold.addEventListener("click", function() {
    if ($1ee2b6306238ec66$var$playing) {
        // 1 Add current score to active player's score
        $1ee2b6306238ec66$var$scores[$1ee2b6306238ec66$var$activePlayer] += $1ee2b6306238ec66$var$currentScore;
        document.getElementById(`score--${$1ee2b6306238ec66$var$activePlayer}`).textContent = $1ee2b6306238ec66$var$scores[$1ee2b6306238ec66$var$activePlayer];
        // 2 Check if player's score is >= 100
        if ($1ee2b6306238ec66$var$scores[$1ee2b6306238ec66$var$activePlayer] >= 100) {
            // 3 Finish the game
            $1ee2b6306238ec66$var$playing = false;
            $1ee2b6306238ec66$var$diceEl.classList.add("hidden");
            document.querySelector(`.player--${$1ee2b6306238ec66$var$activePlayer}`).classList.add("player--winner");
            document.querySelector(`.player--${$1ee2b6306238ec66$var$activePlayer}`).classList.remove("player--active");
        } else // 4 Switch to next player
        $1ee2b6306238ec66$var$switchPlayer();
    }
});
// Reset
$1ee2b6306238ec66$var$btnNew.addEventListener("click", $1ee2b6306238ec66$var$init);


//# sourceMappingURL=index.dc40fdac.js.map
